/**
 * Label for a firm team member used as account manager for a client.
 * Prefers displayName from API / Users list; never treats Cognito as UX copy.
 *
 * @param {{ ownerUserId?: string|null, ownerDisplayName?: string|null, displayName?: string|null }} row
 * @returns {string}
 */
export const formatOwnerLabel = (row) => {
  if (!row?.ownerUserId) return 'No account manager';
  const name = row.ownerDisplayName || row.displayName
  if (name) return name
  return 'Team member'
};

/**
 * Label for a firm Users row (Cognito `sub`).
 * @param {{ name?: string, surname?: string, email?: string, sub?: string }} user
 * @returns {string}
 */
export const formatFirmUserLabel = (user) => {
  if (!user) return 'Team member'
  return [user.name, user.surname].filter(Boolean).join(' ').trim() || user.email || 'Team member'
}

/**
 * Build BrandSelect options from organisation.users (firm Users / team).
 * Id is always Cognito `sub` — same space as work-item assigneeUserId / ownerUserId.
 * @param {Array<{ sub?: string, name?: string, surname?: string, email?: string }>} users
 * @param {{ emptyLabel?: string }} [opts]
 * @returns {Array<{ value: string, label: string }>}
 */
export const firmUserOwnerOptions = (users, opts = {}) => {
  const emptyLabel = opts.emptyLabel || 'No account manager'
  const out = [{ value: '', label: emptyLabel }]
  ;(users || []).forEach((u) => {
    if (!u?.sub) return
    out.push({ value: u.sub, label: formatFirmUserLabel(u) })
  })
  return out
}

/**
 * Assignee picker options: firm Users plus Unassigned (not limited to client owners).
 * @param {Array<{ sub?: string, name?: string, surname?: string, email?: string }>} users
 * @returns {Array<{ value: string, label: string }>}
 */
export const firmUserAssigneeOptions = (users) =>
  firmUserOwnerOptions(users, { emptyLabel: 'Unassigned' })
